<template>
  <div class="bg_main" v-resize="onResize">

    <div v-if="!hasPagination" class="d-flex justify-center align-center" style="height: 80vh;">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="isMobile" class="mobile">
        <v-row class="pt-0 pb-0">
          <v-col cols="9" class="pt-0 pb-0">
            <v-text-field
                type="text"
                solo
                placeholder="Buscar en mis trámites"
                v-model="search"
                @keyup.enter="getProceduresList"
            />
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-btn class="main_color white--text" large @click="getProceduresList">
              <v-icon class="main_color white--text">
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <h2 class="h2" v-if="proceduresStore.filterStatus === 1">
          Trámites pendientes
        </h2>
        <h2 v-else-if="proceduresStore.filterStatus === 2">
          Trámites completados y/o finalizados
        </h2>
        <h2 v-else-if="proceduresStore.filterStatus === 3">
          Trámites cancelados
        </h2>
        <h2 v-else-if="proceduresStore.filterStatus === 5">
          Trámites en proceso de revisión y/o validación
        </h2>
        <h2 class="h2" v-else>Todos los trámites del ciudadano</h2>
        <v-card
            v-for="procedure in procedures"
            :key="procedure.id"
            :class="[getStatusColor(procedure.status.name) + '_card_mobile','mb-2',]">
          <v-card-title style="word-break:normal">
            {{ procedure.process.name }}
          </v-card-title>
          <v-card-subtitle :class="getStatusColor(procedure.status.name) + '--text'" style="text-align:left">
            {{ procedure.status.male_label }}
          </v-card-subtitle>

          <v-card-text>
            <v-row style="opacity: 0.8;">
              <v-col cols="5" class="fecha-col-mobil mr-2">
                <v-row>
                  <p class="fecha-mobil" style="margin: 0">
                    {{ procedure.stages.length > 0 ? procedure.stages[0].created_at : '' }}
                  </p>
                </v-row>
              </v-col>
              <v-col cols="5" class="fecha-col-mobil ml-2">
                <v-row>
                  <p class="fecha-mobil" style="margin: 0">
                    {{ procedure.stages.length > 0 ? procedure.stages[0].task.name : '' }}
                  </p>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <!-- <v-btn
                class="primary_border btn-mobile"
                small
                @click="showProcedureStages(procedure.stages)">
                <img class="ico_item_action"  :src="$renderImageFromAssets('icon_show_progress')"/>
                Ver Proceso
            </v-btn> -->
            <v-btn depressed class="primary_border main_color white--text" small
                   @click="showProcedureStages(procedure.stages)">
              <!-- <img class="ico_item_action"  :src="$renderImageFromAssets('icon_show_progress')"/> -->
              Ver Proceso
            </v-btn>

            <!-- <v-btn class="success_border btn-mobile" small @click="router.push({ name: 'procedure_continue', params: { stageId: procedure.stages[0].id } })">
                <img class="ico_item_action"  :src="$renderImageFromAssets('icon_continue')"/> Continuar trámite
            </v-btn> -->
            <router-link
                v-if="procedure.status.name === 'active'"
                class="text-decoration-none"
                :to="{name: 'procedure_continue', params: { stageId: procedure.stages[0].id }}">
              <v-btn depressed class="success_border botoncolorsegundo white--text" small>
                <!-- <img class="ico_item_action"  :src="$renderImageFromAssets('icon_continue')"/> -->
                Continuar trámite
              </v-btn>
            </router-link>

            <v-menu
                v-if="procedure.status.name === 'finished'"
                offset-y
                origin="center center"
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="primary_border main_color white--text"
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    small>
                  <!-- <v-icon color="primary" small left>fas fa-eye</v-icon> -->
                  Ver historial
                  <v-icon x-small right>fas fa-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <template v-for="stage in procedure.stages">
                  <v-list-item
                      v-if="stage.status.name === 'finished' && stage.user_assigned != null &&
                                                      stage.user_assigned.id == accountStore.user.id" :key="stage.id">
                    <v-list-item-title>
                      <router-link
                          :to="{name: 'procedure_view', params: { stageId: stage.id }}"
                          class="text-decoration-none main_color--text">
                        {{ stage.task.name }}
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>

            <!-- <v-menu
                v-if="procedure.status.name === 'finished'"
                offset-y
                origin="center center"
                transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="primary_border btn-mobile" v-bind="attrs" v-on="on" tile small>
                        <v-icon color="primary" small left class="ico_history--eye">
                            fas fa-eye
                        </v-icon>
                        Ver historial
                        <v-icon class="ico_history--chevron" small right>
                            fas fa-chevron-down
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <template v-for="stage in procedure.stages">
                        <v-list-item
                            v-if="
                                stage.status.name === 'finished' &&
                                stage.user_assigned != null &&
                                stage.user_assigned.id == accountStore.user.id"
                            :key="stage.id">
                            <v-list-item-title>
                                <router-link :to="{ name: 'procedure_view',params: { stageId: stage.id },}"
                                    class="text-decoration-none">
                                    {{ stage.id }} - {{ stage.task.name }}
                                </router-link>
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-list>
            </v-menu> -->
          </v-card-actions>
          <!--<div class="pl-1">
              <v-row>
                  <v-col cols="12" class="py-3 px-6 nombre-tramite-mobil">
                      <h4>{{ procedure.process.name }}</h4>
                  </v-col>
              </v-row>
              <v-row>
                  <v-col class="font-weight-bold pl-6 status-mobil">
                      <p :class="getStatusColor(procedure.status.name) + '--text'" style="margin: 0">
                          {{ procedure.status.male_label }}
                      </p>
                  </v-col>
              </v-row>
              <v-row style="opacity: 0.8;">
                  <v-col cols="2" class="fecha-col-mobil ml-9 mr-2">
                      <v-row>
                          <p class="fecha-mobil-label mr-1">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 36.449 36.448" style="enable-background: new 0 0 36.449 36.448" xml:space="preserve"><g>
                                  <g><rect x="12.858" y="14.626" width="4.596" height="4.089"/><rect x="18.996" y="14.626" width="4.595" height="4.089"/><rect x="25.128" y="14.626" width="4.596" height="4.089"/><rect x="6.724" y="20.084" width="4.595" height="4.086"/><rect x="12.858" y="20.084" width="4.596" height="4.086"/><rect x="18.996" y="20.084" width="4.595" height="4.086"/><rect x="25.128" y="20.084" width="4.596" height="4.086"/><rect x="6.724" y="25.54" width="4.595" height="4.086"/><rect x="12.858" y="25.54" width="4.596" height="4.086"/><rect x="18.996" y="25.54" width="4.595" height="4.086"/><rect x="25.128" y="25.54" width="4.596" height="4.086"/>
                                      <path d="M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75V12.099h-2.5v20.099    c0,2.343,1.907,4.25,4.25,4.25h24c2.344,0,4.25-1.907,4.25-4.25V12.099h-2.5V32.198z"/>
                                      <path d="M30.224,3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75    c0-1.517-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75    c-1.473,0-2.67,1.233-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v2h2.5h27.5h2.5v-2    C34.474,5.855,32.568,3.948,30.224,3.948z M11.466,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75    c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M19.546,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25    V2.75c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M27.626,7.646c0,0.689-0.525,1.25-1.17,1.25    c-0.646,0-1.17-0.561-1.17-1.25V2.75c0-0.689,0.524-1.25,1.17-1.25c0.645,0,1.17,0.561,1.17,1.25V7.646z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                              </svg>
                          </p>
                          <p class="fecha-mobil" style="margin: 0">
                              {{procedure.stages.length > 0 ? procedure.stages[0].created_at: ""}}
                          </p>
                      </v-row>
                  </v-col>
                  <v-col cols="4" class="fecha-col-mobil ml-2">
                      <v-row>
                          <p class="fecha-mobil" style="margin: 0">
                              {{ procedure.stages.length > 0 ? procedure.stages[0].task.name : "" }}
                          </p>
                      </v-row>
                  </v-col>
              </v-row>

              <div
                  class="procedure-stages-mobile"
                  style="position: absolute; bottom: 0">
                  <v-row>
                      <v-col cols="12 pt-0 d-flex" class="pill-mobile">
                          <v-btn
                              class="primary_border btn-mobile"
                              small
                              @click="showProcedureStages(procedure.stages)">
                              <img class="ico_item_action"  :src="$renderImageFromAssets('icon_show_progress')"/>
                              Ver Proceso
                          </v-btn>
                          PENDIENTE
                          <router-link
                              v-if="procedure.status.name === 'active'"
                              class="text-decoration-none"
                              :to="{ name: 'procedure_continue', params: { stageId: procedure.stages[0].id },}">
                              <v-btn class="success_border btn-mobile" small>
                                  <img class="ico_item_action"  :src="$renderImageFromAssets('icon_continue')"/> Continuar trámite
                              </v-btn>
                          </router-link>

                          TERMINADO
                          <v-menu
                              v-if="procedure.status.name === 'finished'"
                              offset-y
                              origin="center center"
                              transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn class="primary_border btn-mobile" v-bind="attrs" v-on="on" tile small>
                                      <v-icon color="primary" small left class="ico_history--eye">
                                          fas fa-eye
                                      </v-icon>
                                      Ver historial
                                      <v-icon class="ico_history--chevron" small right>
                                          fas fa-chevron-down
                                      </v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <template v-for="stage in procedure.stages">
                                      <v-list-item
                                          v-if="
                                              stage.status.name === 'finished' &&
                                              stage.user_assigned != null &&
                                              stage.user_assigned.id == accountStore.user.id"
                                          :key="stage.id">
                                          <v-list-item-title>
                                              <router-link :to="{ name: 'procedure_view',params: { stageId: stage.id },}"
                                                  class="text-decoration-none">
                                                  {{ stage.id }} - {{ stage.task.name }}
                                              </router-link>
                                          </v-list-item-title>
                                      </v-list-item>
                                  </template>
                              </v-list>
                          </v-menu>
                      </v-col>
                  </v-row>
              </div>
          </div>-->
        </v-card>
      </div>


      <!--<v-row>
          <v-col cols="6" sm="6" md="6" lg="3" v-for="(card, index) in cards" :key="card.value">
              DASHBOARD CARDS
              <v-card
                  class="mx-auto dash_cards"
                  :class="'bg_home_card_' + (index + 1)"
                  max-width="344"
                  outlined
                  link
                  @click="filterProceduresList(card.id)"
              >
                  <v-list-item three-line>
                      <v-avatar
                          v-bind:color="'bg_home_card_' + (index + 1) + '_avatar'"
                          size="62"
                      >
                          <img
                              class="ico_card"
                              :src="$renderImageFromAssets('icon_home_card_' + (index + 1))"
                          />
                      </v-avatar>

                      <v-list-item-content class="right-auto">
                          <v-card-subtitle class="pb-0 text-uppercase">
                              <span class="font-weight-bold">{{ card.title }} </span>
                              <span>{{ getCountNumber(card.status) }}</span>
                          </v-card-subtitle>
                      </v-list-item-content>
                  </v-list-item>
                  <div
                      class="sub_text_card pb-2"
                      :class="'bg_home_card_' + (index + 1) + '_title'"
                  >
                      <v-icon color="white">fas fa-sort-amount-down-alt</v-icon>
                  </div>
              </v-card>
          </v-col>
      </v-row>-->

      <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
      <v-row class="" v-if="!isMobile">
        <v-col cols="11" class="pt-0 pb-0">
          <v-text-field
              type="text"
              solo
              placeholder="Buscar en mis trámites"
              v-model="search"
              @keyup.enter="getProceduresList"
          />
        </v-col>
        <v-col cols="1" class="pt-0 pb-0">
          <v-btn class="main_color white--text" large @click="getProceduresList">
            <v-icon class="main_color white--text">
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title class="title_table--text font-weight-bold" v-if="isMobile">
              <template v-if="proceduresStore.filterStatus === 1">
                Trámites pendientes
              </template>
              <template v-else-if="proceduresStore.filterStatus === 2">
                Trámites completados y/o finalizados
              </template>
              <template v-else-if="proceduresStore.filterStatus === 3">
                Trámites cancelados
              </template>
              <template v-else-if="proceduresStore.filterStatus === 5">
                Trámites en proceso de revisión y/o validación
              </template>
              <template v-else-if="proceduresStore.filterStatus === 7">
                Nuevo Trámite
              </template>
              <template v-else>
                Todos los trámites del ciudadano ({{ proceduresStore.totalCounter }})
              </template>
            </v-card-title>
            <v-simple-table>
              <thead class="bg_table_th">
              <tr>
                <th class="txt_table_th--text">Identificador</th>
                <th class="txt_table_th--text">Nombre del trámite</th>
                <th class="txt_table_th--text">Etapa Actual</th>
                <th class="txt_table_th--text">Fecha Actualización</th>
                <th class="txt_table_th--text">Estatus</th>
                <th class="txt_table_th--text">Acciones</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="procedure in procedures" :key="procedure.id">
                <td>{{ procedure.id }}</td>
                <td>{{ procedure.process.name }}</td>
                <td>{{ procedure.stages.length > 0 ? procedure.stages[0].task.name : '' }}</td>
                <td>{{ procedure.stages.length > 0 ? procedure.stages[0].created_at.replaceAll('-', '/') : '' }}</td>
                <td>
                  <div style="display: flex">
                    <v-icon dense :color="getStatusColor(procedure.status.name)">
                      {{ returnIcon(procedure.status.name) }}
                    </v-icon>
                    <span style="font-size: .8rem">
                                            {{ procedure.status.male_label }}
                                        </span>
                  </div>
                  <!--<v-chip
                      small
                      color="transparent"
                      :text-color="getStatusColor(procedure.status.name)"
                      class="px-0 font-weight-bold"
                  >
                      {{ procedure.status.male_label }}
                  </v-chip>-->
                </td>
                <td>
                  <v-btn depressed class="primary_border main_color white--text" small
                         @click="showProcedureStages(procedure.stages)">
                    <!-- <img class="ico_item_action"  :src="$renderImageFromAssets('icon_show_progress')"/> -->
                    Ver Proceso
                  </v-btn>
                  <!-- PENDIENTE -->
                  <router-link
                      v-if="procedure.status.name === 'active'"
                      class="text-decoration-none"
                      :to="{name: 'procedure_continue', params: { stageId: procedure.stages[0].id }}">
                    <v-btn depressed class="success_border botoncolorsegundo white--text" small>
                      <!-- <img class="ico_item_action"  :src="$renderImageFromAssets('icon_continue')"/> -->
                      Continuar trámite
                    </v-btn>
                  </router-link>

                  <!-- TERMINADO -->
                  <v-menu
                      v-if="procedure.status.name === 'finished'"
                      offset-y
                      origin="center center"
                      transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="primary_border main_color white--text"
                          v-bind="attrs"
                          v-on="on"
                          depressed
                          small>
                        <!-- <v-icon color="primary" small left>fas fa-eye</v-icon> -->
                        Ver historial
                        <v-icon x-small right>fas fa-chevron-down</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <template v-for="stage in procedure.stages">
                        <v-list-item
                            v-if="stage.status.name === 'finished' && stage.user_assigned != null &&
                                                        stage.user_assigned.id == accountStore.user.id" :key="stage.id">
                          <v-list-item-title>
                            <router-link
                                :to="{name: 'procedure_view', params: { stageId: stage.id }}"
                                class="text-decoration-none main_color--text">
                              {{ stage.task.name }}
                            </router-link>
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <div class="text-center pa-2 pb-4">
        <v-pagination
            color="main_color"
            v-if="hasPagination"
            v-model="page"
            :length="paginator.total_pages"
            total-visible="10"
            @input="getProceduresList"
        ></v-pagination>
      </div>

      <!-- END TABLE FOR PROCESSES   -->
      <procedure-stages show-modal=""></procedure-stages>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import ProcedureStages from '@/components/dashboard/ProcedureStages';
import {
  getProcedureStatusColor,
  getProcedureStatusIcon,
} from '@/core/assets_utils';
import router from '@/config/router';
import {procedureListRequest} from '@/api/models';

export default {
  name: 'Dashboard',
  components: {ProcedureStages},
  computed: {
    ...mapState({
      accountStore: (state) => state.account,
      proceduresStore: (state) => state.procedures,
    }),
    ...mapGetters('procedures', ['hasPagination', 'paginator', 'procedures']),
  },
  data() {
    return {
      TOTAL_COUNT: 0,
      FILTER_STATUS_ACTIVE: 1,
      FILTER_STATUS_FINISHED: 2,
      FILTER_STATUS_CANCELED: 3,
      FILTER_STATUS_DELETED: 4,
      FILTER_STATUS_IN_PROCESS: 5,

      cards: [
        {
          id: 1,
          status: 'active',
          title: 'Pendientes',
          color: 'bg_home_card_1',
          css: 'card_1',
        },
        {
          id: 5,
          status: 'in-process',
          title: 'En Proceso',
          color: 'bg_home_card_2',
          css: 'card_2',
        },
        {
          id: 3,
          status: 'canceled',
          title: 'Cancelados',
          color: 'bg_home_card_3',
          css: 'card_3',
        },
        {
          id: 2,
          status: 'finished',
          title: 'Completados',
          color: 'bg_home_card_4',
          css: 'card_4',
        },
      ],
      page: 1,
      pageLimit: 10,
      procedureStages: [],
      showProcedureStagesModal: false,
      fab: false,
      isMobile: false,
      search: '',
    };
  },

  created() {
    this.$gtag.event('home', {method: 'Google'});
  },

  mounted() {
    this.waitForUser(() => {
      this.clearProcedures();
      this.getProceduresList();
      this.countProcedures();
    });
  },


  methods: {
    ...mapActions('procedures', [
      'getProceduresByUser',
      'clearProcedures',
      'getProceduresCount',
    ]),
    ...mapMutations('procedures', ['showList']),
    ...mapMutations('appBar', ['changeViewOpened']),
    waitForUser(callback) {
      const interval = setInterval(() => {
        if (this.accountStore.user && this.accountStore.user.id) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    },

    returnIcon(status) {
      let icon = '';
      switch (status) {
        case 'active':
          icon = 'mdi-clock-time-eight-outline';
          break;

        case 'finished':
          icon = 'mdi-check';
          break;

        case 'in-process':
          icon = 'mdi-lightning-bolt';
          break;

        case 'canceled':
          icon = 'mdi-close-thick';
          break;

        case 'deleted':
          icon = 'mdi-trash-can';
          break;

        default:
          icon = 'mdi-alert';
          break;
      }
      return icon;
    },

    filterProcedures() {
      /* let filter = this.procedures.filter((procedure) =>
          procedure.process.name.toLowerCase().includes(this.search.toLowerCase())
      ); */
      // this.showList(filter);
    },

    getProceduresList() {
      let request = procedureListRequest();
      request.userId = this.accountStore.user ? this.accountStore.user.id : 0;
      request.status = this.proceduresStore.filterStatus;
      request.limit = this.proceduresStore.pageLimit;
      request.page = this.page;
      request.query = this.search;

      this.getProceduresByUser(request);
    },

    countProcedures() {
      this.getProceduresCount();
    },

    showProcedureStages(stages) {
      this.showProcedureStagesModal = true;
      this.procedureStages = stages;
    },

    getCountNumber(status) {
      if (this.proceduresStore.proceduresCounter) {
        if (status === 'active') {
          return this.proceduresStore.proceduresCounter.pending;
        } else if (status === 'in-process') {
          return this.proceduresStore.proceduresCounter.in_process;
        } else if (status === 'canceled') {
          return this.proceduresStore.proceduresCounter.canceled;
        } else if (status === 'finished') {
          return this.proceduresStore.proceduresCounter.complete;
        }
      }

      return 0;
    },

    getStatusColor(status) {
      return getProcedureStatusColor(status);
    },

    getStatusIcon(status) {
      return getProcedureStatusIcon(status);
    },

    filterProceduresList(filterStatus) {
      this.currentFilter = filterStatus;

      if (filterStatus < 6 && router.currentRoute.name !== 'home') {
        router.push({name: 'home'});
      }

      if (filterStatus !== this.proceduresStore.filterStatus) {
        let request = procedureListRequest();
        request.userId = this.accountStore.user.id;
        request.status = filterStatus;
        request.limit = this.proceduresStore.pageLimit;

        this.getProceduresByUser(request);
      }
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>

<style scoped>

.theme--light.v-pagination .v-pagination__navigation {
  background: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
}

/* .bg_main .v-speed-dial {
    position: absolute;
}

#bg_main .v-btn--floating {
    position: relative;
}

.bg_main .v-list-item {
    padding: 0px !important;
}

.bg_main .v-list-item__content {
    padding: 0px !important;
}

.bg_main .v-list-item {
    min-height: auto !important;
}

.bg_main .dash_cards .v-avatar {
    border-radius: 5px 0px 0px 0px !important;
    width: 45px !important;
    height: 45px !important;
    min-width: 45px !important;
}

.bg_main .v-card {
    border-radius: 5px 5px 0px 0px !important;
}

.bg_main .v-list-item__content {
    border-radius: 0px 5px 0px 0px !important;
}

.bg_main .v-card__subtitle {
    text-align: center;
    padding: 3px 16px 0px 16px !important;
}

.bg_main .sub_text_card {
    text-align: center;
    color: #fff;
    padding-top: 8px;
    font-size: 12px;
}

.bg_main .sub_text_card span {
    margin-left: 15px;
    margin-right: 15px;
}

.bg_main .ico_card {
    background-size: cover;
    width: 25px;
    height: 25px;
}

.bg_main .card_4 .ico_card {
    background-image: url("../assets/img/completado_c.png");
}

.bg_main .v-card__subtitle > span {
    color: #fff !important;
    padding-right: 10px;
}

.bg_main .v-chip {
    border-radius: 0px !important;
}

.v-chip .ico_status {
    background-size: cover;
    width: 15px;
    height: 15px;
    margin-right: 7px;
    margin-left: -4px;
}

.ico_item_action{
    width: 15px;
    height: 15px;
    margin-right: 5px;
    margin-left: -5px;
}

.flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 50%;
    height: 70px;
    font-weight: bold;
} */

/*Dashboard mobile styles */
/* .mobile {
    width: 524px;
    margin: 0 auto;
    max-width: 100%;
    display: block;
}
.status_active_card_mobile {
    border-left: 6px solid var(--v-status_active-base);
}
.status_process_card_mobile {
    border-left: 6px solid var(--v-status_process-base);
}
.status_canceled_card_mobile {
    border-left: 6px solid var(--v-status_canceled-base);
}
.status_finished_card_mobile {
    border-left: 6px solid var(--v-status_finished-base);
}
.status-mobil {
    padding-top: 1px;
    padding-left: 27px !important;
    height: 20px;
    margin-bottom: 6px;
    font-size: 0.8rem;
}
.fecha-col-mobil {
    padding: 0 !important;
}
.fecha-mobil-label {
    margin-top: -2px;
    margin-bottom: 0;
    font-weight: 400;
    opacity: 0.6;
    width: 0.7rem;
}
.fecha-mobil {
    font-size: 0.7rem;
    font-weight: 400;
    margin-top: 3px;
}
.nombre-tramite-mobil {
    font-size: 1rem;
    padding: 12px 25px 0px 24px !important;
}

.procedure-stages-mobile {
    position: absolute;
    bottom: 0;
}
.pill-mobile {
    background-color: ghostwhite;
    padding: 0 0px 0px 5px;
    margin-left: 8px;
    margin-bottom: 10px;
    border-radius: 0 15px 15px 0;
}
.ico_progreso,
.ico_continuar {
    width: 12px;
    height: 12px;
}
.ico_history--chevron {
    font-size: 10px !important;
    margin-left: 0px !important;
}
.ico_history--eye {
    font-size: 11px !important;
    margin-right: 2px !important;
}
.v-btn:not(.v-btn--round).v-size--small {
    height: 26px;
    font-size: 0.6rem;
}
.btn-mobile {
    box-shadow: none;
    background-color: inherit !important;
    border-radius: 4px;
    border: none;
    margin: 4px 0 4px 0px;
    font-size: 0.7rem !important;
}

.btn-mobile:before {
    opacity: 0;
}
.mobile .v-card {
    height: 155px;
}
.v-btn.v-size--small {
    font-size: 0.6 rem;
}
.v-chip.v-size--small {
    border-radius: 12px !important;
    font-size: 10px;
    height: 24px;
}
.bg_main .v-card {
    border-radius: 5px !important;
} */
</style>
